<div id="home-factoring" class="container px-4">
  <div class="row">
    <div class="col-12 col-lg-5 ps-3 ps-lg-4  border-linea border-radius-2 border-secondary-factoring-600">
      <p class="primary-800 tabs">SEGO <span class="secondary-factoring-500">Factoring</span></p>
      <h1 class="primary-900">Invierte en las <br>mejores facturas</h1>
    </div>
    <div class="col-12 col-lg-7 gx-0 d-flex flex-column justify-content-end">
      <p class="p2-medium neutral-500 my-2">
        Invierte con SEGO Factoring y obtén <strong class="p2-bold">rentabilidades de hasta un 11,5%
          anual</strong>.
      </p>
      <div class="link-container mb-2">
        @if (isPlatformFactoring) {
        <a id="home-factoring-claves" routerLink="/como-funciona"
          class="link1-bold primary-900 d-flex align-items-center" title="Saca partido al adelanto de facturas">
          <span class="me-1 d-flex">Saca partido al adelanto de facturas</span>
          <span class="material-symbols-outlined">arrow_forward</span>
        </a>
        }
        @if (!isPlatformFactoring) {
        <a id="home-factoring-claves" href="{{domainUrl + '/como-funciona'}}"
          class="link1-bold primary-900 d-flex align-items-center" title="Saca partido al adelanto de facturas">
          <span class="me-1 d-flex">Saca partido al adelanto de facturas</span>
          <span class="material-symbols-outlined">arrow_forward</span>
        </a>
        }
      </div>
    </div>
    <div class="col-12 mt-3 mb-2 bg-primary-100 border-radius-4 p-2">
      <div class="mx-3 mx-lg-4">
        <p class="p3-regular neutral-900">Producto ofrecido por Smart and Small SL. No sujeto al
          Reglamento (UE) 2020/1503 del Parlamento Europeo y por tanto, no está supervisado por CNMV.</p>
      </div>
    </div>
  </div>

  @if (isLoading) {
  <div class="mt-5 p-5">
    <app-is-loading [color]="'factoring'"></app-is-loading>
  </div>
  }

  @if (!isLoading && oportunidadFactoring) {
  <div class="row mt-2 fadein">
    <div class="col-12 gx-0 mx-auto">
      <a id="home-ficha-factoring-{{oportunidadFactoring.nombreOperacionShort}}"
        class="row gx-0 mt-2 mt-lg-4 d-flex align-items-center justify-content-center bg-primary-50 primary-900 oportunidad-factoring border-1 border-radius-2 border-primary-300 pointer shadow-4"
        href="{{domainUrl + '/oportunidades-inversion'}}" title="Ver operación">
        <div class="col-12 p-4">
          <div class="d-none d-lg-block">
            <div class="operacion-codigo float-end">
              <app-sellos [tipoOperacionCodigo]="oportunidadFactoring.tipoOperacionCodigo" [size]="75"></app-sellos>
            </div>
          </div>
          <div class="d-flex d-lg-none align-items-center mb-3">
            <div class="operacion-codigo-mobile">
              <app-sellos [tipoOperacionCodigo]="oportunidadFactoring.tipoOperacionCodigo" [size]="40"></app-sellos>
            </div>
            <span class="ms-3 t2-m primary-900">Operación
              {{oportunidadFactoring.tipoOperacionCodigo.replace('-','
              ')}}</span>
          </div>
          @if (oportunidadFactoring.nombreOperacion && oportunidadFactoring.nombreOperacion.length <= 30) { <h2
            class="h2-semibold primary-900 mb-3 mb-lg-2">
            {{oportunidadFactoring.nombreOperacion}}
            </h2>
            }
            @if (oportunidadFactoring.nombreOperacion && oportunidadFactoring.nombreOperacion.length > 30) {
            <h2 matTooltip={{oportunidadFactoring.nombreOperacion}} matTooltipPosition="below"
              class="h2-semibold primary-900 mb-3 mb-lg-2">
              {{oportunidadFactoring.nombreOperacionShort}}
            </h2>
            }
            <p class="p2-medium neutral-800 d-none d-lg-block">{{oportunidadFactoring.descripcion}}</p>
            <div class="d-sm-flex justify-content-between align-items-end w-100 mb-1">
              <p class="p2-cifras">{{oportunidadFactoring.capitalSolicitado | euroCurrency}}</p>
              <p class="p2-regular neutral-900 mb-1">{{oportunidadFactoring.capitalRecaudado | euroCurrency }}
                conseguidos | {{oportunidadFactoring.porcientoFinanciado}}%
              </p>
            </div>
            <app-progress-bar [porcientoCompletado]="oportunidadFactoring.porcientoFinanciado"></app-progress-bar>
            <div class="d-none d-lg-block">
              <div class="row mt-4">
                <div class="col-2">
                  <p class="neutral-800 p2-medium mb-2">Plazo</p>
                  <p class="p2-bold">{{oportunidadFactoring.plazo}} días
                  </p>
                </div>
                <div class="col-2">
                  <p class="neutral-800 p2-medium mb-2">Tipo de interés</p>
                  <p class="p2-medium"><span class="p2-bold">{{oportunidadFactoring.tasaInteres}}%</span>
                    anual</p>
                </div>
                <div class="col-3">
                  <p class="neutral-800 p2-medium mb-2">Inversión mínima</p>
                  <p class="p2-bold">
                    {{oportunidadFactoring.ticketMinimo}} €
                  </p>
                </div>
                <div class="col-3">
                  <p class="neutral-800 p2-medium mb-2">Tipo interés demora</p>
                  <p class="p2-medium"><span class="p2-bold">{{oportunidadFactoring.tasaInteresDemora}}%</span> anual
                  </p>
                </div>
                <div class="col-2">
                  <p class="neutral-800 p2-medium mb-2 d-flex align-items-start"><span class="me-1">Rating
                    </span>
                    <span class="pointer material-symbols-outlined filled text-dark mat-icon-size-18"
                      (click)="matTooltipRatingHome1.toggle()">
                      info</span>
                    <span class="text-justify" matTooltipClass='sego-secondary-tooltip'
                      #matTooltipRatingHome1="matTooltip" matTooltipPosition='right'
                      (click)="matTooltipRatingHome1.toggle()"
                      matTooltip="¿Qué es el rating de una empresa?   Todas las empresas serán analizadas estableciéndose un rating en el que 1 es riesgo máximo (o la peor calificación posible para una empresa) y el 10, la mejor calificación. Al seleccionar un rating de 7, por ejemplo, se aceptarían los proyectos con un rating de 7 o superior."></span>
                  </p>
                  <p class="p2-bold">{{oportunidadFactoring.riesgo}}</p>
                </div>
              </div>
            </div>
            <div class="d-block d-lg-none mt-3">
              <div class="row mb-2">
                <div class="col-6">
                  <p class="neutral-800 p2-medium">Plazo</p>
                </div>
                <div class="col-6 text-end">
                  <p class="p2-bold">{{oportunidadFactoring.plazo}} días</p>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-6">
                  <p class="neutral-800 p2-medium">Tipo interés</p>
                </div>
                <div class="col-6 text-end">
                  <p class="p2-regular"><span class="p2-bold">{{oportunidadFactoring.tasaInteres}}%</span>
                    anual</p>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-6">
                  <p class="neutral-800 p2-medium">Inversión mínima</p>
                </div>
                <div class="col-6 text-end">
                  <p class="p2-bold">{{oportunidadFactoring.ticketMinimo}} €
                  </p>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-6">
                  <p class="neutral-800 p2-medium">Tasa interés demora</p>
                </div>
                <div class="col-6 text-end">
                  <p class="p2-regular"><span class="p2-bold">{{oportunidadFactoring.tasaInteresDemora}}%</span> anual
                  </p>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-6">
                  <p class="neutral-800 p2-medium d-flex align-items-center">Rating
                    <span class="pointer material-symbols-outlined text-dark mat-icon-size-18 ms-1"
                      (click)="matTooltipRatingHome2.toggle()">
                      info
                    </span>
                    <span class="text-justify" matTooltipClass='sego-secondary-tooltip'
                      #matTooltipRatingHome2="matTooltip" matTooltipPosition='right'
                      (click)="matTooltipRatingHome2.toggle()"
                      matTooltip="¿Qué es el rating de una empresa?   Todas las empresas serán analizadas estableciéndose un rating en el que 1 es riesgo máximo (o la peor calificación posible para una empresa) y el 10, la mejor calificación. Al seleccionar un rating de 7, por ejemplo, se aceptarían los proyectos con un rating de 7 o superior.">
                    </span>
                  </p>
                </div>
                <div class="col-6 text-end">
                  <p class="p2-bold">{{oportunidadFactoring.riesgo}}</p>
                </div>
              </div>
            </div>
        </div>
      </a>
    </div>
  </div>
  }

  @if (!isLoading && !oportunidadFactoring) {
  <div class="row mt-3 mt-lg-4 fadein">
    <div class="col-12 gx-0">
      <app-subiendo-oportunidades [line]="'factoring'"></app-subiendo-oportunidades>
    </div>
  </div>
  }

  <div class="mt-4 text-center">
    @if (isPlatformFactoring) {
    <a id="home-oportunidades-factoring" class="btn btn-primary" title="Ver todas las oportunidades"
      routerLink="/oportunidades-inversion">
      <div class="d-flex align-items-center justify-content-center">
        <span>Ver todas las oportunidades</span> <span class="material-symbols-outlined ms-2">chevron_right</span>
      </div>
    </a>
    }
    @if (!isPlatformFactoring) {
    <a id="home-oportunidades-factoring" class="btn btn-primary" title="Ver todas las oportunidades"
      href="{{domainUrl + '/oportunidades-inversion'}}">
      <div class="d-flex align-items-center justify-content-center">
        <span>Ver todas las oportunidades</span> <span class="material-symbols-outlined ms-2">chevron_right</span>
      </div>
    </a>
    }
  </div>
</div>